import { AddIcon, Button, Dropdown, WidgetSizeEnum } from '@wonderschool/common-base-ui';
import { useTranslation } from 'react-i18next';

interface CreateBillingDropdownProps {
  onCreateInvoice: () => void;
  onCreateBillingPlan: () => void;
  disabled?: boolean;
}

export function CreateBillingDropdown({ onCreateInvoice, onCreateBillingPlan, disabled }: CreateBillingDropdownProps) {
  const { t } = useTranslation();
  return (
    <Dropdown
      data-testid="create-billing-dropdown"
      items={[
        {
          label: t('One Time Charge'),
          onClick: onCreateInvoice,
          extraClasses: 'data-testid-create-invoice-option',
        },
        {
          label: t('Billing Plan'),
          onClick: onCreateBillingPlan,
          extraClasses: 'data-testid-create-billing-plan-option',
        },
      ]}
    >
      <Button
        data-testid="create-billing-button"
        primary
        size={WidgetSizeEnum.SMALL}
        postIcon={<AddIcon className="size-5" />}
        disabled={disabled}
      >
        {t('Create')}
      </Button>
    </Dropdown>
  );
}
